import $ from 'jquery';

(() => {
  const $nav = $('.Navigator');

  $nav.each((i, nav) => {
    const $thisNav = $(nav);
    const $navLinks = $thisNav.find('.Navigator-links').children();
    const $navContents = $thisNav.find('.Navigator-content');
    const $navBg = $thisNav.find('.Navigator-background');
    const $prevLink = $thisNav.find('.Navigator-prev');
    const $nextLink = $thisNav.find('.Navigator-next');
    const secondaryNav = (!!$prevLink && !!$nextLink);
    const isFixedHeight = $thisNav.hasClass('Navigator--fixed');

    function setMinContentHeight() {
      let height = $navContents.first().height();
      $navContents.each(function findMaxHeight() { height = ($(this).height() > height) ? $(this).height() : height; });
      $navContents.parent().css('min-height', height);
    }

    function onTapClick() {
      const index = $(this).attr('data-index') || $(this).index();
      const $navLink = $navLinks.eq(index);
      const $currentContent = $navContents.eq(index);
      const $currentBg = $navBg.eq(index);

      $navContents.removeClass('is-active');
      $currentContent.addClass('is-active');
      $navBg.removeClass('is-active');
      $currentBg.addClass('is-active');

      $navLink.addClass('is-active').siblings().removeClass('is-active');

      if (secondaryNav) {
        if ($navLink.prev()) $prevLink.text($navLink.prev().text()).attr('data-index', $navLink.prev().index());
        if ($navLink.next()) $nextLink.text($navLink.next().text()).attr('data-index', $navLink.next().index());
      }

      let currentVideo = $currentContent.find('video');

      if (currentVideo.length > 0) {
        currentVideo = currentVideo.get(0);
        currentVideo.pause();
        currentVideo.currentTime = 0;
        currentVideo.play();
      }
    }

    if (secondaryNav) {
      $nextLink.text($navLinks[1].innerText).attr('data-index', '1');
      $prevLink.on('tap click', onTapClick);
      $nextLink.on('tap click', onTapClick);
    }

    if (isFixedHeight) {
      setMinContentHeight();
      $(window).on('resize', setMinContentHeight);
    }

    $navLinks.on('tap click', onTapClick);
  });
})();
